import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { CollapsibleModule } from '@surfline/quiver-react';
import subregionPropType from '../../propTypes/subregion';
import trackForecastOutlookLink from '../../utils/trackForecastOutlookLink';
import config from '../../config';
import createAccessibleOnClick from '../../utils/createAccessibleOnClick';

const getSetRegionClassNames = (isLoggedIn, subregions) =>
  classNames({
    'sl-feed-forecast-header__set-region__message': true,
    'sl-feed-forecast-header__set-region__message--list': isLoggedIn && !!subregions.length,
  });

const handleSetRegion = (sub, onSetHomeForecast, doTrackFeed) => {
  onSetHomeForecast(sub._id);
  doTrackFeed('Clicked Set Region', {
    subregionId: sub._id,
    subregionName: sub.name,
  });
};

const getSetRegionMessage = (isLoggedIn, subregions, doTrackFeed) => {
  if (!isLoggedIn || !subregions.length) {
    return (
      <p>
        <a
          href={config.onboardingUrl}
          onClick={() =>
            trackForecastOutlookLink(doTrackFeed, {
              linkName: 'Add favorites',
              linkUrl: config.onboardingUrl,
            })
          }
        >
          Add favorites
        </a>{' '}
        to personalize your headlines and forecasts.
      </p>
    );
  }
  return (
    <p>
      Regions above are displayed based on spots in your
      <a
        href={config.favoritesUrl}
        onClick={() =>
          trackForecastOutlookLink(doTrackFeed, {
            linkName: 'Favorites',
            linkUrl: config.favoritesUrl,
          })
        }
      >
        Favorites
      </a>{' '}
      list.
    </p>
  );
};

const FeedForecastHeader = ({
  doTrackFeed,
  isLoggedIn,
  onSetHomeForecast,
  subregionName,
  subregions,
  mapUrl,
}) => (
  <div className="sl-feed-forecast-header">
    <CollapsibleModule title={`${subregionName}`}>
      <div className="sl-feed-forecast-header__set-region">
        {isLoggedIn && subregions.length ? (
          <ul className="sl-feed-forecast-header__set-region__menu">
            {subregions.map(sub => (
              <li
                className="sl-feed-forecast-header__set-region__menu__item"
                key={sub._id}
                {...createAccessibleOnClick(() =>
                  handleSetRegion(sub, onSetHomeForecast, doTrackFeed)
                )}
              >
                {sub.name}
              </li>
            ))}
          </ul>
        ) : null}
        <div className={getSetRegionClassNames(isLoggedIn, subregions)}>
          {getSetRegionMessage(isLoggedIn, subregions, doTrackFeed)}
        </div>
      </div>
    </CollapsibleModule>
    <a
      className="sl-feed-forecast-header__link"
      href={mapUrl}
      onClick={() =>
        trackForecastOutlookLink(doTrackFeed, {
          linkName: 'View Area on Map',
          linkUrl: mapUrl,
        })
      }
    >
      View Area on Map
    </a>
  </div>
);

FeedForecastHeader.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  doTrackFeed: PropTypes.func.isRequired,
  onSetHomeForecast: PropTypes.func.isRequired,
  subregionName: PropTypes.string.isRequired,
  subregions: PropTypes.arrayOf(subregionPropType).isRequired,
  mapUrl: PropTypes.string.isRequired,
};

export default FeedForecastHeader;
